import type { i18n } from 'i18next';

export const formatPercentage = (percentage: number, i18next: i18n): string => {
  // falls back to English when in dev mode ('cimode')
  return Intl.NumberFormat(i18next.language === 'cimode' ? 'en' : i18next.language, {
    style: 'percent',
  }).format(percentage / 100);
};
